import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject, zip, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AMapService } from '../../shared/amap.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { Getter } from '../../base/interfaces';

const TAG = 'AmapInfoWindow';

@Injectable()
export class AmapInfoWindowService implements Getter<AMap.InfoWindow> {
  private map: AMap.Map;
  private infoWindow: AMap.InfoWindow;
  private infoWindow$ = new ReplaySubject<AMap.InfoWindow>(1);

  constructor(private amaps: AMapService, private logger: LoggerService, private ngZone: NgZone) {}

  /**
   * è·åä¿¡æ¯çªä½
   */
  get() {
    return this.infoWindow$.asObservable();
  }

  /**
   * åå»º AMap.InfoWindow
   * @param options éé¡¹
   */
  create(options: AMap.InfoWindow.Options) {
    return this.amaps.get().pipe(
      map(m => {
        this.map = m;
        this.infoWindow = this.ngZone.runOutsideAngular(() => new AMap.InfoWindow(options));
        this.logger.d(TAG, 'new InfoWindow created.');
        this.infoWindow$.next(this.infoWindow);
        this.infoWindow$.complete();
        return this.infoWindow;
      }),
    );
  }

  /**
   * éæ¯
   */
  destroy() {
    this.get().subscribe(w => {
      w.close();
      this.logger.d(TAG, 'InfoWindow destroyed.');
      this.infoWindow = null;
      this.map = null;
    });
  }

  /**
   * æå¼
   */
  open(position?: AMap.LocationValue) {
    this.get().subscribe(w => w.open(this.map, position));
  }

  /**
   * å¨è¦çç©ä¸æå¼çªä½
   */
  openOnMark(marker: Observable<AMap.Marker | AMap.Text>) {
    zip(marker, this.get()).subscribe(([m, w]) => {
      w.open(this.map, m.getPosition());
    });
  }

  /**
   * å³é­
   */
  close() {
    this.get().subscribe(w => w.close());
  }
}
